import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { QrSettings } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useQrSettingsQuery = () => {
  const branch = useBranchId();
  return useQuery<QrSettings>({
    queryKey: ["qrSettings", branch],
    queryFn: () =>
      get2(
        `/internal/secure/pos/v1/table/live/order/tracker/settings/${branch}`
      ),
  });
};

export default useQrSettingsQuery;
